import { Skeleton, SkeletonText, Stack, useColorModeValue } from '@chakra-ui/react';
import React, { ReactNode } from 'react';
import { colors } from '../Stitches';

type SkeletonType = 'Text' | 'Bar' | 'SingleWord' | 'List';

type FetchingProps = {
  isFetching: boolean;
  skeletonType?: SkeletonType;
  children: ReactNode;
};

const SkeletonList = ({ startColor }: { startColor: string }) => (
  <Stack spacing={2}>
    <Skeleton startColor={startColor} rounded="base" w="full" h={8}></Skeleton>
    <Skeleton startColor={startColor} rounded="base" w="full" h={8}></Skeleton>
    <Skeleton startColor={startColor} rounded="base" w="full" h={8}></Skeleton>
  </Stack>
);

export const Fetching = ({ isFetching, skeletonType, children }: FetchingProps) => {
  const startColor = useColorModeValue('purple.100', colors.ldPurple);
  if (isFetching) {
    switch (skeletonType) {
      case 'Bar':
        return <Skeleton startColor={startColor} h={16}></Skeleton>;
      case 'SingleWord':
        return <Skeleton startColor={startColor} w={32} h={5}></Skeleton>;
      case 'List':
        return <SkeletonList startColor={startColor} />;
      default:
        return <SkeletonText startColor={startColor} w="full" h="full"></SkeletonText>;
    }
  } else {
    return <>{children}</>;
  }
};
